const { default: handleAccordionClick } = require("/src/components/accordion/accordion");

const servicesGroups = document.querySelector('.services-groups');

servicesGroups?.addEventListener('click', handleAccordionClick);